import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex picker-controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_custom_date_picker = _resolveComponent("custom-date-picker")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_time_picker = _resolveComponent("time-picker")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showDialog,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDialog) = $event)),
      width: `${_ctx.dialogWidth}px`,
      persistent: ""
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_text_field, _mergeProps({ ...props, ..._ctx.textFieldProps }, {
          modelValue: _ctx.selectedDateAsLocaleString,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDateAsLocaleString) = $event)),
          class: [
            _ctx.extraSmallHeight ? 'extra-small-height' : '',
            _ctx.dateIsValid && !_ctx.textFieldProps['error-messages'] ? 'mb-2' : ''
          ],
          label: _ctx.label,
          "data-testid": `${_ctx.testid}-text-field`,
          readonly: "",
          hint: _ctx.hint,
          "persistent-hint": _ctx.showHint,
          "hide-details": (!_ctx.showHint || _ctx.dateIsValid) && !_ctx.textFieldProps['error-messages']
        }), {
          "prepend-inner": _withCtx(() => [
            _createVNode(_component_v_icon, {
              "data-testid": `${_ctx.testid}-calendar-icon`,
              color: _ctx.showDialog ? 'primary' : undefined,
              style: {"pointer-events":"auto"},
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
              onClick: _withModifiers(_ctx.handleIconClick, ["stop"])
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" mdi-calendar ", -1)
              ]))]),
              _: 1
            }, 8, ["data-testid", "color", "onClick"])
          ]),
          _: 1
        }, 16, ["modelValue", "class", "label", "data-testid", "hint", "persistent-hint", "hide-details"])
      ]),
      default: _withCtx(() => [
        (_ctx.datepickerType !== 'day')
          ? (_openBlock(), _createBlock(_component_custom_date_picker, {
              key: 0,
              modelValue: _ctx.selectedDateString,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDateString) = $event)),
              testid: _ctx.testid,
              style: _normalizeStyle({ width: `${_ctx.dialogWidth}px` }),
              type: _ctx.datepickerType,
              max: _ctx.maxDateUtc.toISOString(),
              min: _ctx.minDateUtc.toISOString()
            }, null, 8, ["modelValue", "testid", "style", "type", "max", "min"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "picker-row",
                style: _normalizeStyle({ width: `${_ctx.dialogWidth}px` })
              }, [
                _withDirectives(_createVNode(_component_v_date_picker, {
                  modelValue: _ctx.selectedDateString,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDateString) = $event)),
                  class: _normalizeClass({ 'date-picker-with-time': _ctx.showTimepicker }),
                  width: `${_ctx.datePickerWidth}px`,
                  "data-testid": `${_ctx.testid}-date-picker`,
                  "allowed-dates": _ctx.allowedDates,
                  color: "primary",
                  "header-color": "primary",
                  "hide-title": "",
                  "first-day-of-week": "1",
                  "weekday-format": "short",
                  rounded: false,
                  max: _ctx.maxDateUtc.toISOString(),
                  min: _ctx.minDateUtc.toISOString()
                }, {
                  header: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedDateAsLocaleString), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class", "width", "data-testid", "allowed-dates", "max", "min"]), [
                  [_vShow, _ctx.showDatepicker]
                ]),
                (_ctx.showTimepicker)
                  ? (_openBlock(), _createBlock(_component_time_picker, {
                      key: 0,
                      modelValue: _ctx.selectedTime,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTime) = $event)),
                      "default-time": _ctx.defaultTime,
                      class: "time-picker-panel",
                      style: _normalizeStyle({ width: `${_ctx.timePickerWidth}px` }),
                      testid: _ctx.testid,
                      date: _ctx.selectedDate,
                      max: _ctx.maxDateUtc.toISOString(),
                      min: _ctx.minDateUtc.toISOString()
                    }, null, 8, ["modelValue", "default-time", "style", "testid", "date", "max", "min"]))
                  : _createCommentVNode("", true)
              ], 4)
            ])),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "outlined",
            class: "ma-3",
            "data-testid": `${_ctx.testid}-reset-btn`,
            onClick: _ctx.resetDate
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("delete")), 1)
            ]),
            _: 1
          }, 8, ["data-testid", "onClick"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            class: "ma-3",
            "data-testid": `${_ctx.testid}-ok-btn`,
            disabled: !_ctx.dateIsValid,
            onClick: _ctx.emitSelectedDate
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("ok")), 1)
            ]),
            _: 1
          }, 8, ["data-testid", "disabled", "onClick"])
        ]),
        (!_ctx.datesInOrder)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              "data-testid": "error-message-date-order",
              class: "v-tooltip__content date_error_message",
              style: _normalizeStyle({ width: `${_ctx.dialogWidth}px` })
            }, _toDisplayString(_ctx.errorMessageDateOrder), 5))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ]))
}